/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Media Blog API
 * API сервиса статей (MVP).
 * OpenAPI spec version: 1.12.0
 */
import { fetcher } from '../../../utils/fetcher';
import type {
  DeleteAdminV1CategoriesId204,
  EntityCategory,
  EntityCreateCategoryReq,
  EntityUpdateCategoryReq,
  ErrorhandlerErrorResponse,
  PostAdminV1Categories201,
  PutAdminV1CategoriesId204,
} from '../../models';

/**
 * Create a new category with name and icon_id
 * @summary Create a new category
 */
export type postAdminV1CategoriesResponse201 = {
  data: PostAdminV1Categories201;
  status: 201;
};

export type postAdminV1CategoriesResponse400 = {
  data: ErrorhandlerErrorResponse;
  status: 400;
};

export type postAdminV1CategoriesResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type postAdminV1CategoriesResponseComposite =
  | postAdminV1CategoriesResponse201
  | postAdminV1CategoriesResponse400
  | postAdminV1CategoriesResponse500;

export type postAdminV1CategoriesResponse =
  postAdminV1CategoriesResponseComposite & {
    headers: Headers;
  };

export const getPostAdminV1CategoriesUrl = () => {
  return `/admin/v1/categories`;
};

export const postAdminV1Categories = async (
  entityCreateCategoryReq: EntityCreateCategoryReq,
  options?: RequestInit
): Promise<postAdminV1CategoriesResponse> => {
  return fetcher<postAdminV1CategoriesResponse>(getPostAdminV1CategoriesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(entityCreateCategoryReq),
  });
};

/**
 * Update the name and icon of a category by ID
 * @summary Update category by ID
 */
export type putAdminV1CategoriesIdResponse204 = {
  data: PutAdminV1CategoriesId204;
  status: 204;
};

export type putAdminV1CategoriesIdResponse400 = {
  data: ErrorhandlerErrorResponse;
  status: 400;
};

export type putAdminV1CategoriesIdResponse404 = {
  data: ErrorhandlerErrorResponse;
  status: 404;
};

export type putAdminV1CategoriesIdResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type putAdminV1CategoriesIdResponseComposite =
  | putAdminV1CategoriesIdResponse204
  | putAdminV1CategoriesIdResponse400
  | putAdminV1CategoriesIdResponse404
  | putAdminV1CategoriesIdResponse500;

export type putAdminV1CategoriesIdResponse =
  putAdminV1CategoriesIdResponseComposite & {
    headers: Headers;
  };

export const getPutAdminV1CategoriesIdUrl = (id: string) => {
  return `/admin/v1/categories/${id}`;
};

export const putAdminV1CategoriesId = async (
  id: string,
  entityUpdateCategoryReq: EntityUpdateCategoryReq,
  options?: RequestInit
): Promise<putAdminV1CategoriesIdResponse> => {
  return fetcher<putAdminV1CategoriesIdResponse>(
    getPutAdminV1CategoriesIdUrl(id),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(entityUpdateCategoryReq),
    }
  );
};

/**
 * Delete a category by its ID
 * @summary Delete category by ID
 */
export type deleteAdminV1CategoriesIdResponse204 = {
  data: DeleteAdminV1CategoriesId204;
  status: 204;
};

export type deleteAdminV1CategoriesIdResponse404 = {
  data: ErrorhandlerErrorResponse;
  status: 404;
};

export type deleteAdminV1CategoriesIdResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type deleteAdminV1CategoriesIdResponseComposite =
  | deleteAdminV1CategoriesIdResponse204
  | deleteAdminV1CategoriesIdResponse404
  | deleteAdminV1CategoriesIdResponse500;

export type deleteAdminV1CategoriesIdResponse =
  deleteAdminV1CategoriesIdResponseComposite & {
    headers: Headers;
  };

export const getDeleteAdminV1CategoriesIdUrl = (id: string) => {
  return `/admin/v1/categories/${id}`;
};

export const deleteAdminV1CategoriesId = async (
  id: string,
  options?: RequestInit
): Promise<deleteAdminV1CategoriesIdResponse> => {
  return fetcher<deleteAdminV1CategoriesIdResponse>(
    getDeleteAdminV1CategoriesIdUrl(id),
    {
      ...options,
      method: 'DELETE',
    }
  );
};

/**
 * Retrieve the list of all categories
 * @summary Get all categories
 */
export type getV1CategoriesResponse200 = {
  data: EntityCategory[];
  status: 200;
};

export type getV1CategoriesResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type getV1CategoriesResponseComposite =
  | getV1CategoriesResponse200
  | getV1CategoriesResponse500;

export type getV1CategoriesResponse = getV1CategoriesResponseComposite & {
  headers: Headers;
};

export const getGetV1CategoriesUrl = () => {
  return `/v1/categories`;
};

export const getV1Categories = async (
  options?: RequestInit
): Promise<getV1CategoriesResponse> => {
  return fetcher<getV1CategoriesResponse>(getGetV1CategoriesUrl(), {
    ...options,
    method: 'GET',
  });
};
